import { useState, useEffect, useMemo } from "react";
import { Capacitor } from "@capacitor/core";
import { T } from "../../theme.js";

const ScheduleIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="#5E8C65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{display:"block"}}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
    <line x1="8" y1="14" x2="8" y2="14"/>
    <line x1="12" y1="14" x2="12" y2="14"/>
    <line x1="16" y1="14" x2="16" y2="14"/>
    <line x1="8" y1="18" x2="8" y2="18"/>
    <line x1="12" y1="18" x2="12" y2="18"/>
  </svg>
);
const FairnessIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="#C4A050" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{display:"block"}}>
    <line x1="12" y1="3" x2="12" y2="21"/>
    <path d="M5 21h14"/>
    <path d="M5 8l-3 6h6l-3-6z"/>
    <path d="M19 8l-3 6h6l-3-6z"/>
    <line x1="5" y1="8" x2="19" y2="8"/>
  </svg>
);
const PeopleIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="#7B6BAE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{display:"block"}}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const HomeIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="#C17B4E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{display:"block"}}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);
const GearIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="#9B6BAE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{display:"block"}}>
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);
const InboxIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="#4A8FA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{display:"block"}}>
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/>
    <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
  </svg>
);
import { usePeople } from "../../context/PeopleContext.jsx";
import { supabase } from "../../supabaseClient.js";
import { _CAL_MONTHS } from "../../utils/calendarUtils.js";
import { getDisplayName } from "../../utils/displayName.js";
import { resizeFileToDataUrl } from "../../utils/helpers.js";

function isNotifKindEnabled(kind, settings) {
  if (!kind || !settings) return true;
  if (kind === "scheduling_request" || kind === "scheduling_counter" ||
      kind === "scheduling_counter_sent") return settings.proposals !== false;
  if (kind === "scheduling_response" || kind === "scheduling_cancelled" ||
      kind === "scheduling_counter_outcome" || kind === "scheduling_expired") return settings.confirmations !== false;
  if (kind === "reminder") return settings.reminders !== false;
  if (kind === "fairness") return settings.fairness !== false;
  if (kind === "drift") return settings.drift !== false;
  if (kind === "anchor" || kind === "anchors") return settings.anchors !== false;
  return true;
}

const SCREENS=[
  {id:"onboarding",label:"Onboarding", icon:"👋",group:"entry"},
  {id:"second-user",label:"Alex joins",icon:"👤",group:"entry"},
  {id:"home",      label:"Home",       icon:<HomeIcon/>,group:"main"},
  {id:"people",    label:"People",     icon:<PeopleIcon/>,group:"main"},
  {id:"schedule",  label:"Schedule",   icon:<ScheduleIcon/>,group:"main"},
  {id:"calendars", label:"Calendar",   icon:"📅",group:"main"},
  {id:"inbox",     label:"Inbox",      icon:<InboxIcon/>,group:"main"},
  {id:"settings",  label:"Settings",   icon:<GearIcon/>,group:"util"},
];
import { OnboardingContent, SecondUserContent } from "../onboarding/index.jsx";
import { HomeContent } from "../home/HomeContent.jsx";
import { PeopleContent } from "../people/PeopleContent.jsx";
import { ScheduleContent } from "../schedule/ScheduleContent.jsx";
import { CalendarContent } from "../calendar/CalendarContent.jsx";
import { InboxContent } from "../inbox/InboxContent.jsx";
import { SettingsContent } from "../settings/SettingsContent.jsx";

function useInboxUnreadCount() {
  const { notifs, notifSettings, privOverrides, people: PEOPLE } = usePeople();
  // Mirror InboxContent's deletedNotifs so the badge doesn't show locally-deleted items after a reload.
  const deletedNotifIds = useMemo(() => {
    try {
      const v = localStorage.getItem("orbit_deleted_notifs");
      return new Set((v ? JSON.parse(v) : []).map(n => n.id));
    } catch { return new Set(); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // intentionally once on mount — live deletions are already removed from `notifs` in context
  return notifs.filter(n => {
    if (n.read) return false;
    if (!isNotifKindEnabled(n.kind, notifSettings)) return false;
    if (deletedNotifIds.has(n.id)) return false;
    // Mirror InboxContent's personEnabled: hide notifs from unlinked/muted people
    // (but always show connection/scheduling requests regardless of person status)
    const ALWAYS_SHOW_KINDS = new Set(["connection_request","scheduling_request","scheduling_response","scheduling_cancelled"]);
    if (!ALWAYS_SHOW_KINDS.has(n.kind) && n.ini) {
      const p = PEOPLE.find(x => x.ini === n.ini);
      if (!p || !p.linkedUserId) return false;
      if (privOverrides?.[p.id]?.notif === false) return false;
    }
    return true;
  }).length;
}

export function MobileShell({
  screen,onNav,schedulePersonId,scheduleType,scheduleMode,calendarDay,inboxNotifId,peopleType,navResets,settingsInitialSection,googleOAuthError,outlookOAuthError,yahooOAuthError,caldavConnectError,inviteToken,onTakeTour}){
  const {notifs,notifSettings}=usePeople();
  const isEntry=screen==="onboarding"||screen==="second-user";
  const unreadCount=useInboxUnreadCount();
  const nav=[
    {id:"home",     icon:<HomeIcon/>,label:"Home"},
    {id:"people",   icon:<PeopleIcon/>,label:"People"},
    {id:"schedule", icon:<ScheduleIcon/>,label:"Schedule"},
    {id:"calendars",icon:"📅",label:"Calendar"},
    {id:"inbox",    icon:<InboxIcon/>,label:"Inbox"},
  ];
  const isNativeApp = Capacitor.isNativePlatform();
  return(<div style={{width:"100%",maxWidth:isNativeApp?undefined:390,height:"100%",background:T.bg,display:"flex",flexDirection:"column",fontFamily:"'DM Sans',sans-serif",position:"relative",overflow:"hidden",paddingTop:"env(safe-area-inset-top, 0px)",paddingLeft:"env(safe-area-inset-left, 0px)",paddingRight:"env(safe-area-inset-right, 0px)"}}>
    {!isEntry&&<div style={{padding:"8px 18px 8px",flexShrink:0}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <img src="/orbit-logo.png" alt="Orbit" style={{width:28,height:28,objectFit:"contain",flexShrink:0}}/>
        <span style={{fontSize:13,fontFamily:"'Crimson Pro',serif",fontWeight:600,color:T.ink}}>orbit</span>
        <button onClick={()=>onNav("settings")} aria-label="Settings" style={{marginLeft:"auto",background:"none",border:"none",cursor:"pointer",padding:4,display:"flex",alignItems:"center",justifyContent:"center",opacity:0.7}}>
          <GearIcon/>
        </button>
      </div>
    </div>}
    <div style={{flex:1,display:"flex",flexDirection:"column",overflowY:"auto",animation:"fadeUp .25s ease"}}>
      {screen==="onboarding"&&<OnboardingContent onNav={onNav}/>}
      {screen==="second-user"&&<SecondUserContent onNav={onNav} inviteToken={inviteToken}/>}
      {screen==="home"&&<HomeContent key={navResets?.home||0} onNav={onNav} isMobile={true}/>}
      {screen==="people"&&<PeopleContent key={navResets?.people||0} onNav={onNav} isMobile={true} initialType={peopleType}/>}
      {screen==="schedule"&&<ScheduleContent key={navResets?.schedule||0} onNav={onNav} isMobile={true} schedulePersonId={schedulePersonId} scheduleType={scheduleType} scheduleMode={scheduleMode}/>}
      {screen==="calendars"&&<CalendarContent key={navResets?.calendars||0} onNav={onNav} isMobile={true} initialDay={calendarDay}/>}
      {screen==="inbox"&&<InboxContent key={navResets?.inbox||0} onNav={onNav} isMobile={true} initialNotifId={inboxNotifId}/>}
      {screen==="settings"&&<SettingsContent key={navResets?.settings||0} onNav={onNav} isMobile={true} initialSection={settingsInitialSection} googleOAuthError={googleOAuthError} outlookOAuthError={outlookOAuthError} yahooOAuthError={yahooOAuthError} caldavConnectError={caldavConnectError} onTakeTour={onTakeTour}/>}
    </div>
    {!isEntry&&<nav aria-label="Main navigation" style={{background:"rgba(253,248,242,0.96)",backdropFilter:"blur(12px)",borderTop:`1px solid ${T.edge}`,display:"flex",justifyContent:"space-around",paddingBottom:"max(18px, env(safe-area-inset-bottom, 18px))",paddingTop:7,flexShrink:0,zIndex:50}}>
      {nav.map(item=>(
        <button key={item.id} onClick={()=>onNav(item.id)} aria-label={item.label} aria-current={screen===item.id?"page":undefined} style={{flex:"1 1 0",minWidth:0,border:"none",background:"transparent",display:"flex",flexDirection:"column",alignItems:"center",gap:3,cursor:"pointer",padding:"5px 4px"}}>
          <div style={{position:"relative",display:"inline-flex"}}>
            <span aria-hidden="true" style={{fontSize:16,color:screen===item.id?T.clay:T.muted}}>{item.icon}</span>
            {item.id==="inbox"&&unreadCount>0&&(
              <div aria-label={`${unreadCount} unread`} style={{position:"absolute",top:-4,right:-6,minWidth:14,height:14,borderRadius:7,background:T.red,border:"1.5px solid "+T.bg,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 3px"}}>
                <span aria-hidden="true" style={{fontSize:11,fontWeight:700,color:"white",lineHeight:1}}>{unreadCount>9?"9+":unreadCount}</span>
              </div>
            )}
          </div>
          <span aria-hidden="true" style={{fontSize:11,fontWeight:screen===item.id?700:400,color:screen===item.id?T.clay:T.muted}}>{item.label}</span>
          {screen===item.id&&<div style={{width:14,height:2,borderRadius:1,background:T.clay}}/>}
        </button>
      ))}
    </nav>}
  </div>);
}

export function DesktopShell({
  screen,onNav,schedulePersonId,scheduleType,scheduleMode,calendarDay,inboxNotifId,peopleType,navResets,settingsInitialSection,googleOAuthError,outlookOAuthError,yahooOAuthError,caldavConnectError,inviteToken,onTakeTour}){
  const {people:PEOPLE,notifs,notifSettings,user}=usePeople();
  const unreadCount=useInboxUnreadCount();
  const isEntry=screen==="onboarding"||screen==="second-user";
  const userName=getDisplayName(user,"You");
  const nameParts=userName.split(/\s+/).filter(Boolean);
  const userIni=nameParts.length>=2
    ?(nameParts[0][0]+nameParts[nameParts.length-1][0]).toUpperCase()
    : (nameParts[0]?.slice(0,2).toUpperCase()||"?");
  // Compute fresh on every render so the date never goes stale if the tab stays open
  const todayStr=(()=>{const d=new Date();return`${_CAL_MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;})();
  const nav=[
    {id:"home",      icon:<HomeIcon/>,label:"Home"},
    {id:"people",    icon:<PeopleIcon/>,label:"People"},
    {id:"schedule",  icon:<ScheduleIcon/>,label:"Schedule"},
    {id:"calendars", icon:"📅",label:"Calendars"},
    {id:"inbox",     icon:<InboxIcon/>,label:"Inbox"},
  ];
  if(isEntry) return(
    <div style={{width:"100%",minHeight:"100%",display:"flex",alignItems:"center",justifyContent:"center",background:T.bg,fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{width:"100%",maxWidth:500,background:T.surface,borderRadius:24,overflow:"hidden",boxShadow:"0 8px 48px rgba(60,40,20,.12)",border:`1px solid ${T.edge}`,minHeight:540,display:"flex",flexDirection:"column"}}>
        <div style={{padding:"14px 22px",borderBottom:`1px solid ${T.edge}`,display:"flex",alignItems:"center",gap:10}}>
          <img src="/orbit-logo.png" alt="Orbit" style={{width:30,height:30,objectFit:"contain",flexShrink:0}}/>
          <span style={{fontSize:15,fontFamily:"'Crimson Pro',serif",fontWeight:600,color:T.ink}}>orbit</span>
        </div>
        {screen==="onboarding"&&<OnboardingContent onNav={onNav}/>}
        {screen==="second-user"&&<SecondUserContent onNav={onNav} inviteToken={inviteToken}/>}
      </div>
    </div>
  );
  return(
    <div style={{width:"100%",minHeight:"100%",display:"flex",fontFamily:"'DM Sans',sans-serif",background:T.bg}}>
      <nav aria-label="Main navigation" style={{width:210,flexShrink:0,background:T.surface,borderRight:`1px solid ${T.edge}`,display:"flex",flexDirection:"column",padding:"20px 0"}}>
        <div style={{padding:"0 20px 18px",borderBottom:`1px solid ${T.edge}`,marginBottom:14}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <img src="/orbit-logo.png" alt="Orbit" style={{width:32,height:32,objectFit:"contain",flexShrink:0}}/>
            <span style={{fontSize:19,fontFamily:"'Crimson Pro',serif",fontWeight:600,color:T.ink}}>orbit</span>
            <button onClick={()=>onNav("settings")} aria-label="Settings" aria-current={screen==="settings"?"page":undefined} style={{marginLeft:"auto",background:screen==="settings"?T.clay+"12":"none",border:"none",cursor:"pointer",padding:5,borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",transition:"all .15s"}}>
              <GearIcon/>
            </button>
          </div>
        </div>
        {nav.map(item=>(
          <button key={item.id} onClick={()=>onNav(item.id)} aria-label={item.label} aria-current={screen===item.id?"page":undefined} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 20px",border:"none",cursor:"pointer",textAlign:"left",background:screen===item.id?T.clay+"12":"transparent",borderRight:screen===item.id?`3px solid ${T.clay}`:"3px solid transparent",transition:"all .15s"}}>
            <span aria-hidden="true" style={{fontSize:15,color:screen===item.id?T.clay:T.muted,flexShrink:0,width:18,display:"inline-flex",alignItems:"center",justifyContent:"center"}}>{item.icon}</span>
            <span aria-hidden="true" style={{fontSize:13,fontWeight:screen===item.id?600:400,color:screen===item.id?T.ink:T.muted}}>{item.label}</span>
            {item.id==="inbox"&&unreadCount>0&&screen!=="inbox"&&(
              <span aria-label={`${unreadCount} unread notifications`} style={{marginLeft:"auto",fontSize:11,fontWeight:700,background:T.red,color:"white",borderRadius:9,padding:"1px 6px",lineHeight:1.4}}>{unreadCount>9?"9+":unreadCount}</span>
            )}
          </button>
        ))}
        <div style={{marginTop:"auto",padding:"14px 20px",borderTop:`1px solid ${T.edge}`,display:"flex",alignItems:"center",gap:9}}>
          <div style={{width:28,height:28,borderRadius:"50%",background:T.mist,border:`1.5px solid ${T.edgeMid}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:T.mid,overflow:"hidden",flexShrink:0}}>
            {user?.user_metadata?.photo
              ? <img src={user.user_metadata.photo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
              : userIni}
          </div>
          <div style={{flex:1,minWidth:0}}>
            <p style={{fontSize:12,fontWeight:600,color:T.ink}}>{userName}</p>
            <p style={{fontSize:11,color:T.muted}}>{todayStr}</p>
          </div>
        </div>
      </nav>
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",minHeight:"100%"}}>
        <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column",animation:"fadeUp .22s ease"}}>
          {screen==="home"&&<HomeContent key={navResets?.home||0} onNav={onNav} isMobile={false}/>}
          {screen==="people"&&<PeopleContent key={navResets?.people||0} onNav={onNav} isMobile={false} initialType={peopleType}/>}
          {screen==="schedule"&&<ScheduleContent key={navResets?.schedule||0} onNav={onNav} isMobile={false} schedulePersonId={schedulePersonId} scheduleType={scheduleType} scheduleMode={scheduleMode}/>}
          {screen==="calendars"&&<CalendarContent key={navResets?.calendars||0} onNav={onNav} isMobile={false} initialDay={calendarDay}/>}
          {screen==="inbox"&&<InboxContent key={navResets?.inbox||0} onNav={onNav} isMobile={false} initialNotifId={inboxNotifId}/>}
          {screen==="settings"&&<SettingsContent key={navResets?.settings||0} onNav={onNav} isMobile={false} initialSection={settingsInitialSection} googleOAuthError={googleOAuthError} outlookOAuthError={outlookOAuthError} yahooOAuthError={yahooOAuthError} caldavConnectError={caldavConnectError} onTakeTour={onTakeTour}/>}
        </div>
      </div>
    </div>
  );
}

// ── Profile setup modal ───────────────────────────────────────────────────────
// Shown on first login and whenever the user's profile is missing key fields
// (phone and/or birthday). Dismissed state is session-only so it re-prompts
// at the next login if info is still missing.
export function ProfileSetupModal({onClose}){
  const {user,setUser}=usePeople();
  const initName=getDisplayName(user,"");
  const initFullName=(()=>{const m=user?.user_metadata||{};if(m.legal_full_name)return m.legal_full_name;const parts=[m.first_name||m.given_name,m.last_name||m.family_name].filter(Boolean);if(parts.length)return parts.join(" ");return m.full_name||m.name||"";})();
  const [draft,setDraft]=useState({
    name:initName,
    fullName:initFullName,
    phone:user?.user_metadata?.phone||"",
    birthday:user?.user_metadata?.birthday||"",
    photo:user?.user_metadata?.photo||null,
  });
  const [saving,setSaving]=useState(false);
  const [phoneErr,setPhoneErr]=useState(null);

  const normalizePhone=(raw)=>{
    if(!raw) return "";
    const digits=raw.replace(/\D/g,"");
    if(digits.length===10) return "+1"+digits;
    if(digits.length===11&&digits[0]==="1") return "+"+digits;
    if(/^\+\d{7,15}$/.test(raw.trim())) return raw.trim();
    return null;
  };

  const handlePhotoSelect=(e)=>{
    const file=e.target.files?.[0];if(!file)return;
    resizeFileToDataUrl(file).then(url=>{if(url) setDraft(d=>({...d,photo:url}));});
  };

  const handleSave=async()=>{
    const rawPhone=(draft.phone||"").trim();
    if(rawPhone){
      const norm=normalizePhone(rawPhone);
      if(!norm){setPhoneErr("Enter a valid phone number, e.g. (555) 867-5309 or +15558675309");return;}
      setPhoneErr(null);
    } else { setPhoneErr(null); }
    setSaving(true);
    const newName=(draft.name||"").trim()||initName;
    const newFullName=(draft.fullName||"").trim();
    const newPhone=rawPhone?normalizePhone(rawPhone):"";
    const newBirthday=(draft.birthday||"").trim();
    const newPhoto=draft.photo||null;
    if(newName) saveDisplayName(newName, user?.id);
    try{
      const {data,error}=await supabase.auth.updateUser({
        data:{...(user?.user_metadata||{}),full_name:newName,name_explicitly_set:true,legal_full_name:newFullName||undefined,phone:newPhone,birthday:newBirthday||undefined,photo:newPhoto},
      });
      if(!error&&data?.user){
        setUser(data.user);
        const uid=data.user.id;
        if(uid){
          supabase.from("user_profiles").upsert({
            user_id:uid,
            display_name:newName||null,
            legal_full_name:newFullName||null,
            email:user?.email||null,
            phone:newPhone||null,
            birthday:newBirthday||null,
            photo:newPhoto||null,
            updated_at:new Date().toISOString(),
          },{onConflict:"user_id"}).catch(e => console.error('[profile-setup] user_profiles sync failed:', e));
        }
      }
    }catch(_){}
    setSaving(false);
    onClose();
  };

  const avatarIni=(()=>{
    const parts=(draft.name||initName||"?").trim().split(/\s+/).filter(Boolean);
    return parts.length>=2?(parts[0][0]+parts[parts.length-1][0]).toUpperCase():parts[0]?.slice(0,2).toUpperCase()||"?";
  })();

  return(
    <div role="presentation" style={{position:"fixed",inset:0,zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(30,16,8,0.60)",backdropFilter:"blur(4px)",animation:"fadeIn 0.2s ease"}}>
      <div role="dialog" aria-modal="true" aria-label="Set up your profile" style={{background:T.surface,borderRadius:24,padding:"28px 28px 24px",width:"min(420px,92vw)",boxShadow:"0 24px 80px rgba(30,16,8,0.3)",border:`1px solid ${T.edge}`,animation:"popIn 0.25s ease"}}>
        <div style={{textAlign:"center",marginBottom:20}}>
          <div style={{fontFamily:"'Crimson Pro',serif",fontSize:24,fontWeight:300,color:T.ink,marginBottom:4}}>Set up your profile</div>
          <p style={{fontSize:13,color:T.muted,lineHeight:1.5}}>Help your connections recognize you and coordinate better</p>
        </div>

        {/* Photo */}
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",marginBottom:20}}>
          <label style={{cursor:"pointer",position:"relative",display:"block"}}>
            <div style={{width:72,height:72,borderRadius:"50%",background:`linear-gradient(135deg,${T.partner},${T.coparent})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,fontFamily:"'Crimson Pro',serif",fontWeight:700,color:"white",overflow:"hidden",flexShrink:0}}>
              {draft.photo?<img src={draft.photo} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:avatarIni}
            </div>
            <div style={{position:"absolute",bottom:0,right:0,width:22,height:22,borderRadius:"50%",background:T.clay,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:"white",fontWeight:700,border:`2px solid ${T.surface}`}}>+</div>
            <input type="file" accept="image/*" style={{display:"none"}} onChange={handlePhotoSelect}/>
          </label>
          <p style={{fontSize:11,color:T.muted,marginTop:6}}>Add a photo (optional)</p>
        </div>

        {/* Name */}
        <div style={{marginBottom:14}}>
          <label style={{fontSize:12,fontWeight:600,color:T.bark,display:"block",marginBottom:5}}>Display name <span style={{color:T.clay}}>*</span></label>
          <input
            value={draft.name}
            onChange={e=>setDraft(d=>({...d,name:e.target.value}))}
            placeholder="What should we call you?"
            autoFocus
            style={{width:"100%",padding:"10px 13px",borderRadius:10,border:`1.5px solid ${draft.name.trim()?T.edge:T.clay}`,background:T.bg,fontSize:14,color:T.ink,outline:"none",fontFamily:"inherit"}}
          />
        </div>

        {/* Full name */}
        <div style={{marginBottom:14}}>
          <label style={{fontSize:12,fontWeight:600,color:T.bark,display:"block",marginBottom:5}}>Full name</label>
          <input
            value={draft.fullName}
            onChange={e=>setDraft(d=>({...d,fullName:e.target.value}))}
            placeholder="Legal / full name"
            style={{width:"100%",padding:"10px 13px",borderRadius:10,border:`1.5px solid ${T.edge}`,background:T.bg,fontSize:14,color:T.ink,outline:"none",fontFamily:"inherit"}}
          />
        </div>

        {/* Phone */}
        <div style={{marginBottom:14}}>
          <label style={{fontSize:12,fontWeight:600,color:T.bark,display:"block",marginBottom:5}}>Phone <span style={{fontWeight:400,color:T.muted}}>(optional)</span></label>
          <input
            type="tel"
            value={draft.phone}
            onChange={e=>{setDraft(d=>({...d,phone:e.target.value}));if(phoneErr)setPhoneErr(null);}}
            placeholder="e.g. (555) 867-5309"
            style={{width:"100%",padding:"10px 13px",borderRadius:10,border:`1.5px solid ${phoneErr?T.clay:T.edge}`,background:T.bg,fontSize:14,color:T.ink,outline:"none",fontFamily:"inherit"}}
          />
          {phoneErr&&<p style={{fontSize:11,color:T.clay,marginTop:4,lineHeight:1.4}}>{phoneErr}</p>}
        </div>

        {/* Birthday */}
        <div style={{marginBottom:24}}>
          <label style={{fontSize:12,fontWeight:600,color:T.bark,display:"block",marginBottom:5}}>Birthday <span style={{fontWeight:400,color:T.muted}}>(optional)</span></label>
          <input
            type="date"
            value={draft.birthday}
            onChange={e=>setDraft(d=>({...d,birthday:e.target.value}))}
            style={{width:"100%",padding:"10px 13px",borderRadius:10,border:`1.5px solid ${T.edge}`,background:T.bg,fontSize:14,color:T.ink,outline:"none",fontFamily:"inherit",colorScheme:"light"}}
          />
        </div>

        {/* Buttons */}
        <button
          onClick={handleSave}
          disabled={saving||!draft.name.trim()}
          style={{width:"100%",padding:"12px",borderRadius:12,background:saving||!draft.name.trim()?T.mist:T.bark,color:saving||!draft.name.trim()?T.muted:"white",border:"none",fontSize:14,fontWeight:600,cursor:saving||!draft.name.trim()?"not-allowed":"pointer",marginBottom:10,transition:"all 0.15s"}}
        >
          {saving?"Saving…":"Save profile"}
        </button>
        <button
          onClick={onClose}
          style={{width:"100%",padding:"10px",borderRadius:12,background:"transparent",color:T.muted,border:"none",fontSize:13,cursor:"pointer"}}
        >
          Skip for now
        </button>
      </div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────────────────
